// Web Audio + tab-title chime for boost-code drop moments.
// No external asset required — synthesises a soft two-tone bell via oscillators.

let audioCtx = null;

function getCtx() {
  if (audioCtx) return audioCtx;
  try {
    const Cls = window.AudioContext || window.webkitAudioContext;
    if (Cls) audioCtx = new Cls();
  } catch {}
  return audioCtx;
}

function playTone(ctx, freq, when, dur = 0.6, gain = 0.18) {
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = "sine";
  osc.frequency.setValueAtTime(freq, when);
  g.gain.setValueAtTime(0, when);
  g.gain.linearRampToValueAtTime(gain, when + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0005, when + dur);
  osc.connect(g).connect(ctx.destination);
  osc.start(when);
  osc.stop(when + dur + 0.05);
}

export function playChime() {
  const ctx = getCtx();
  if (!ctx) return;
  // resume if the tab was suspended
  if (ctx.state === "suspended") { try { ctx.resume(); } catch {} }
  const t = ctx.currentTime;
  // pleasant two-note bell — A5 then E6
  playTone(ctx, 880, t, 0.7);
  playTone(ctx, 1318.5, t + 0.18, 0.9, 0.14);
}

export function flashTitle({ blink = "🔔 Boost live — claim now", durationMs = 12000 } = {}) {
  const original = document.title;
  let on = false;
  const id = setInterval(() => {
    on = !on;
    document.title = on ? blink : original;
  }, 900);
  setTimeout(() => {
    clearInterval(id);
    document.title = original;
  }, durationMs);
  return () => { clearInterval(id); document.title = original; };
}
